module.exports = __webpack_public_path__ + "static/media/noun-gym-1396008-808080.a84cdde4.svg";